/**
 * Polyfills
 */
require('inert-polyfill');
require('intersection-observer');
require('lazysizes');
require('smoothscroll-polyfill').polyfill();
